const translations = {
  page_title: 'API Keys',

  settings: 'Settings',
  section_api_keys_description: 'Full list of API keys.',
  section_settings_description: 'General information and accounts associated with this API key.',

  id: 'ID',
  api_key: 'API key',
  enter_api_key: 'Enter API Key',
  invalid_api_key: 'Invalid API Key',
  
  name: 'Name',
  description: 'Description',
  enter_description: 'Enter description',
  invalid_description: 'Invalid description',
  
  accounts: 'Accounts',
  enter_accounts: 'Enter accounts',
  invalid_accounts: 'Invalid accounts',

  filters: 'Filters',
  section_filters_description: 'Configure the information of the filters that are displayed in the inventory. If they are left blank, they will show information based on existing inventory.',

  year_from: 'Year from',
  enter_year_from: 'Enter year from',
  invalid_year_from: 'Invalid year from',

  year_to: 'Year to',
  enter_year_to: 'Enter year to',
  invalid_year_to: 'Invalid year to',

  sort: 'Sort',
  enter_sort: 'Enter sort',
  invalid_sort: 'Invalid sort',

  sort_direction: 'Sort direction',
  enter_sort_direction: 'Enter sort direction',
  invalid_sort_direction: 'Invalid sort direction',

  price_from: 'Price from',
  enter_price_from: 'Enter price from',
  invalid_price_from: 'Invalid price from',

  price_to: 'Price to',
  enter_price_to: 'Enter price to',
  invalid_price_to: 'Invalid price to',

  mileage_from: 'Mileage from',
  enter_mileage_from: 'Enter mileage from',
  invalid_mileage_from: 'Invalid mileage from',

  mileage_to: 'Mileage to',
  enter_mileage_to: 'Enter mileage to',
  invalid_mileage_to: 'Invalid mileage to',

  make: 'Make',
  enter_make: 'Enter make',
  invalid_make: 'Invalid make',

  model: 'Model',
  enter_model: 'Enter model',
  invalid_model: 'Invalid model',

  type: 'Type',
  enter_type: 'Enter type',
  invalid_type: 'Invalid type',

  condition: 'Condition',
  enter_condition: 'Enter condition',
  invalid_condition: 'Invalid condition',
  new: 'New',
  used: 'Used',

  doors: 'Doors',
  enter_doors: 'Enter doors',
  invalid_doors: 'Invalid doors',

  new_api_key: 'New api key',
  no_value: '-',
  api_key_deleted: 'Api key deleted successfully',
  api_key_updated: 'Api key updated successfully',
  api_key_created:  'Api key created successfully',
  api_key_copied: 'Api key copied',
  asc: 'Ascending',
  desc: 'Descending'
};

export default translations;
